/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const s = { ATTRIBUTE: 1, CHILD: 2, EVENT: 5, ELEMENT: 6 }, $ = (r) => (...t) => ({ _$litDirective$: r, values: t });
class _ {
  constructor(t) {
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AT(t, e, i) {
    this._$Ct = t, this._$AM = e, this._$Ci = i;
  }
  _$AS(t, e) {
    return this.update(t, e);
  }
  update(t, e) {
    return this.render(...e);
  }
}
export {
  $ as e,
  _ as i,
  s as t
};
